import React from "react";
import { Container } from "react-bootstrap";
import { compose } from "recompose";
import clsx from "clsx";
import { withTrack, withTrackProps } from "@dpdgroupuk/react-event-tracker";
import PropTypes from "prop-types";
import styles from "./LoginFooter.module.scss";
import { DateUtil } from "../../../../utils";
import { ANALYTICS } from "../../../../constants";
import { useUrlResolver } from "../../../../Context";

const Link = ({
  classes,
  href,
  children,
  onClick
}) => /*#__PURE__*/React.createElement("a", {
  className: clsx(classes),
  href: href,
  onClick: onClick
}, children);

Link.propTypes = {
  classes: PropTypes.array,
  href: PropTypes.string,
  children: PropTypes.oneOf([PropTypes.node, PropTypes.string]),
  onClick: PropTypes.func
};

const LoginFooter = ({
  onClickPrivacyPolicy,
  onClickTermsOfUse
}) => {
  const urlResolver = useUrlResolver();
  return /*#__PURE__*/React.createElement(Container, {
    fluid: true,
    className: styles.footer,
    as: "footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, /*#__PURE__*/React.createElement("p", {
    className: "m-0 d-md-inline"
  }, "Copyright \xA9 ", DateUtil.getYear(), " DPD UK. All rights reserved"), /*#__PURE__*/React.createElement(Link, {
    classes: [styles.text, styles.link, styles.leftPad],
    onClick: onClickPrivacyPolicy,
    href: urlResolver.getUrl("privacy-policy")
  }, "Privacy Policy"), /*#__PURE__*/React.createElement("span", null, "\xA0|\xA0"), /*#__PURE__*/React.createElement(Link, {
    classes: [styles.text, styles.link],
    onClick: onClickTermsOfUse,
    href: urlResolver.getUrl("terms-and-conditions")
  }, "Terms and Conditions")));
};

LoginFooter.propTypes = {
  onClickPrivacyPolicy: PropTypes.func,
  onClickTermsOfUse: PropTypes.func
};
export default compose(withTrack(ANALYTICS.LOGON_FOOTER.LOAD), withTrackProps({
  onClickPrivacyPolicy: ANALYTICS.LOGON_FOOTER.ON_CLICK_PRIVACY_POLICY,
  onClickTermsOfUse: ANALYTICS.LOGON_FOOTER.ON_CLICK_TERMS_OF_USE
}))(LoginFooter);